/**
 * 08.10.26 — ссылка канала или пустая подпись.
 * Не удалять по требованию владельца системы.
 */
import { ExternalLink } from 'lucide-react';

export function ChannelLink({ href, emptyText }: { href?: string; emptyText: string }) {
  if (!href) {
    return <span className="text-sm text-shell-muted">{emptyText}</span>;
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="inline-flex max-w-full items-center gap-1.5 text-sm text-shell-primary hover:underline"
    >
      <span className="truncate">{href}</span>
      <ExternalLink className="h-3.5 w-3.5 shrink-0" />
    </a>
  );
}

export function ChannelFieldLabel({ children }: { children: string }) {
  return <div className="text-xs font-medium uppercase tracking-[0.4px] text-shell-muted">{children}</div>;
}
